<template>
  <div class="switch-lang">
    <div class="current-lang">
      <img :src="`/img/langs/${currentLang}.png`" :alt="`lang ${currentLang}`">
      <fai class="icon" icon="caret-down"></fai>
    </div>
    <ul>
      <li v-for="(lang,i) in langs" :key="i" @click="translate(lang)">
        <img :src="`/img/langs/${lang}.png`" :alt="`lang ${lang}`">
        <span>{{langsText[lang]}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      langs: Object.keys(this.$i18n.messages),
      currentLang: this.$i18n.locale,
      langsText: {
        en: "English",
        fr: "Français"
      }
    };
  },
  mounted() {},
  methods: {
    translate(lg) {
      var newPath = `/${lg}/${this.$route.path.slice(4)}`;
      this.$router.push(newPath);
      window.location = newPath;
    }
  }
};
</script>

<style lang="scss">
.switch-lang {
  display: flex;
  position: relative;
  height: 100%;
  cursor: pointer;
  &:hover {
    background-color: $primary;
    > ul {
      display: block;
    }
  }
  > ul {
    display: none;
    position: absolute;
    top: 100%;
    background-color: $primary;
    width: auto;
    min-width: 100%;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    > li {
      padding: 11px 15px;
      cursor: pointer;
      display: flex;
      align-items: center;
      display: flex;
      align-items: center;
      img {
        width: 35px;
        height: auto;
        margin-right: 10px;
        border: 2px solid #fff;
        border-radius: 50%;
      }
      span {
        display: block;
        color: #fff;
        font-size: $sizeItemMenu;
      }
      &:hover {
        background-color: $primary-D;
      }
    }
  }
  .current-lang {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0 15px;
    img {
      border-radius: 50%;
      width: 35px;
      border-radius: 2px solid transparent;
    }
    .icon {
      margin-left: 10px;
      color: #fff;
    }
    &:hover {
      img {
        border: 2px solid #fff;
      }
    }
  }
}
</style>
